import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import { classNames } from "src/helpers/classNames";

export default function CTASection({ data }) {
  return (
    <section className={classNames(data?.hidden ? "hidden" : "relative mx-auto mt-32 max-w-7xl sm:mt-56 sm:px-6 lg:px-8")}>
      <div className="relative isolate overflow-hidden bg-slate-900 px-6 py-24 shadow-2xl sm:rounded-3xl sm:px-24 xl:py-32">
        <h2 className="mx-auto max-w-3xl text-center text-4xl font-semibold leading-tight tracking-tighter text-white md:text-5xl md:leading-none">{data?.title}</h2>
        <p className="mx-auto mt-6 max-w-xl text-center text-lg leading-normal text-slate-300">{data?.description}</p>
        <div className="mt-16 flex justify-center">
          <Link
            to={data?.button_link}
            target="_blank"
            className="inline-flex items-center gap-2 rounded-full bg-blue-50 px-6 py-3 text-base font-semibold text-blue-600 shadow-lg  transition-colors duration-300 hover:bg-blue-500 hover:text-white">
            <span>{data?.button_text}</span>
            <ArrowRightIcon className="h-5 w-5" />
          </Link>
        </div>

        <svg
          viewBox="0 0 1024 1024"
          aria-hidden="true"
          className="absolute left-1/2 top-1/2 -z-10 h-[64rem] w-[64rem] -translate-x-1/2">
          <circle
            r="512"
            cx="512"
            cy="512"
            fill="url(#759c1415-0410-454c-8f7c-9a820de03641)"
            fill-opacity="0.7"></circle>
          <defs>
            <radialGradient
              r="1"
              cx="0"
              cy="0"
              id="759c1415-0410-454c-8f7c-9a820de03641"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(512 512) rotate(90) scale(512)">
              <stop stop-color="#7775D6"></stop>
              <stop
                offset="1"
                stop-color="#E935C1"
                stop-opacity="0"></stop>
            </radialGradient>
          </defs>
        </svg>
      </div>
    </section>
  );
}
